import { BaseApi } from '@/main/baseApi';
import { OZAKAZKA } from '@/modules/servis/constants';


class DropdownListProvider extends BaseApi {
	GetTablPoz(vyrobekvozOzn: string | number) {
		return this.fetch(`/${this.controller}/GetTablPoz/${vyrobekvozOzn}`);
	}

	GetTypKodMin4(vyrobekvozOzn: string | number, tabulkovaPozic: string | number) {
		return this.fetch(`/${this.controller}/GetTyp_TypKodMin4/${vyrobekvozOzn}/${tabulkovaPozic}`);
	}

	GetProvozovna() {
		return this.fetch(`/${this.controller}/GetProvozovna/`);
	}

	GetPartnertyp() {
		return this.fetch(`/${this.controller}/GetPartnertyp/`);
	}

	GetZakazkadruh() {
		return this.fetch(`/${this.controller}/GetZakazkadruh/`);
	}

	GetSmVaria() {
		return this.fetch(`/${this.controller}/GetSmVaria/`);
	}

	GetDokladDruhSM(provozovnaId: string | number) {
		return this.fetch(`/${this.controller}/GetDokladDruh/${provozovnaId}/10`);
	}

	GetPOZakazka() {
		return this.fetch(`/${this.controller}/GetPOZakazka/`);
	}

	GetOzakazkaStatus(statusArray: any) {
		return this.fetch(`/${this.controller}/Get${OZAKAZKA}Status/`, { ozakazkaPzn: statusArray });
	}

	GetSkladMisto(skladOzn: number) {
		return this.fetch(`/${this.controller}/GetSkladMisto/${skladOzn}`);
	}

	GetUsers(accessRole: string) {
		return this.fetch(`/${this.controller}/GetUsers/${accessRole}`);
	}
}

export const dropdownListProvider = new DropdownListProvider('', 'dropdownList');
